import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import MessageReport from "../../../../../components/messageReport/report";
export const getMessageReportBasePath = () => getAdminBasePath() + "/messageReport";
export const getMessageReportDetailsPath = (id) => `${getMessageReportBasePath()}/message/${id}`;
export const getMessageReportBaseRoute = () => `${getAdminBaseRoute()}/messageReport`;
export const getMessageReportDetailsRoute = () => `${getMessageReportBaseRoute()}/message/:id`;
const AdminMessageReportRoutes = () => {
    return (_jsx(Switch, { children: _jsx(Route, { component: MessageReport, path: getMessageReportBaseRoute() }) }));
};
export default AdminMessageReportRoutes;
